import { POST_ERRORS } from "../post/post-errors.js";

export const COMMENT_ERRORS = {
	NOT_FOUND: "comment_not_found",
	FORBIDDEN: "comment_forbidden",
	POST_NOT_FOUND: POST_ERRORS.NOT_FOUND,
	ALREADY_LIKED: "comment_already_liked",
	NOT_LIKED: "comment_not_liked",
	REPLY_TO_REPLY: "cannot_reply_to_reply",
	ALREADY_DELETED: "comment_already_deleted",
} as const;

export type CommentErrorCode = (typeof COMMENT_ERRORS)[keyof typeof COMMENT_ERRORS];
